export default __webpack_public_path__ + "static/media/avatar.e582e4ba.png";